import styled from 'styled-components';

export const IndexContainer = styled.div`
  main.container {
    display: flex;
    margin: 1rem 1rem;
  }

  main .main-left {
    flex: 1;
    /* width: 80px; */
  }

  main .main-right {
    flex: 5;
    padding: 0 20px;

    
  }

  @media screen and (max-width: 1200px) {
  }

  @media screen and (max-width: 1024px) {
    main .main-left {
      flex: 0;
    }
    main .main-right {
      padding: 0 5px;
    }
  }

  @media screen and (max-width: 600px) {
    main .main-right {
      padding: 0;
    }
  }
`;
